export const money = (amount: number) => `${(amount / 100).toFixed(2).replace('.', ',')} €`;

export function getImageContext(context: string[]) {
  if(context.length === 0) {
    return '';
  }

  if (Object.prototype.hasOwnProperty.call(context, 'fill') && context['fill']) {
    return 'image--fill';
  }

  let classes = '';
  if (Object.prototype.hasOwnProperty.call(context, 'top') && context['top']) {
    classes += 'image--no-top ';
  }

  if (Object.prototype.hasOwnProperty.call(context, 'bottom') && context['bottom']) {
    classes += 'image--no-bottom ';
  }

  return classes.trim();
}
